import { FALSE, TRUE } from "constants/primitives";

import { EU_COUNTRIES, REGION_CHECK_COUNTRIES } from "constants/countries";
import WidgetConfig from "helpers/init/WidgetConfig";
import isScannerApp from "helpers/isScannerApp";
import includes from "helpers/includes";

const shouldUseFullConsent = (
  widgetConfig: WidgetConfig,
  visitorCountry: string | null = null,
  visitorRegion: string | null = null
) => {
  // when scanner app visits, act as if user already consented to all categories
  if (isScannerApp()) {
    return TRUE;
  }

  const { bannerNonEuCountries, bannerNonEuRegions, hideOutsideEU } =
    widgetConfig;

  // when not in EU and settings allow it, act as if user already consented to all categories
  if (hideOutsideEU && !!visitorCountry) {
    let countriesToCheck = [...EU_COUNTRIES, ...bannerNonEuCountries];
    if (visitorRegion) {
      countriesToCheck = [...countriesToCheck, ...REGION_CHECK_COUNTRIES];
    }

    if (!includes(countriesToCheck, visitorCountry)) {
      return TRUE;
    }

    if (
      !!visitorCountry &&
      !!visitorRegion &&
      includes(REGION_CHECK_COUNTRIES, visitorCountry) &&
      !includes(bannerNonEuRegions, `${visitorCountry}-${visitorRegion}`)
    ) {
      return TRUE;
    }
  }

  return FALSE;
};

export default shouldUseFullConsent;
